import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./~/rmc-notification/es/index.js
// module id = 809
// module chunks = 127